// src/StageContent.js
import React from "react";
import { getStageComponent, listStageComponents } from "../../games";

/**
 * StageContent (multi-jeux)
 *
 * - Avant: scannait ./stages globalement.
 * - Maintenant: on route vers le bon jeu via gameId, puis on récupère le composant via un registry.
 *
 * Compat: si gameId est absent, on fallback sur 1 (Origami) => ne casse rien tant que le back n'est pas prêt.
 */
export default function StageContent({
  syncStartedAt,
  syncResetCounter,
  serverNow,
  onMorseUpdated,
  gameId = 1,
  componentName,
  canAdvance,
  isCanAdvance,
  code,
  playerId,
  hintSignal,
  onInventoryUpdate,
  raisedCount,
  raisedPlayers,
  centerMaxH,
  players,
  pseudo,
  pageVariant,
  onSuccessCutsceneStart, 
  onSuccessCutsceneEnd,
  onNavigateToScoreboard
}) {
  const Component = getStageComponent(gameId, componentName);

  if (!Component) {
    const available = listStageComponents(gameId);
    console.warn(
      "❌ Composant introuvable :",
      componentName,
      "— gameId :",
      gameId,
      "— disponibles :",
      available
    );
    return <p>Page non trouvée ({componentName})</p>;
  }

  return (
    <Component
      syncStartedAt={syncStartedAt}
      syncResetCounter={syncResetCounter}
      serverNow={serverNow}
      onMorseUpdated={onMorseUpdated}
      canAdvance={canAdvance}
      isCanAdvance={isCanAdvance}
      code={code}
      playerId={playerId}
      hintSignal={hintSignal}
      onInventoryUpdate={onInventoryUpdate}
      raisedCount={raisedCount}
      raisedPlayers={raisedPlayers}
      centerMaxH={centerMaxH}
      playerCount={players.length}
      pageVariant={pageVariant}
      pseudo={pseudo}
      onSuccessCutsceneStart={onSuccessCutsceneStart}
      onSuccessCutsceneEnd={onSuccessCutsceneEnd}
      onNavigateToScoreboard={onNavigateToScoreboard}
      players={players}
    />
  );
}

